import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Shield } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl border border-[#C8AA6E]/40 bg-[#C8AA6E]/10 mb-4">
            <Shield className="h-7 w-7 text-[#C8AA6E]" />
          </div>
          <h1 className="font-[Outfit] text-3xl font-black text-[#F0E6D2] tracking-tight">
            Panel Admina
          </h1>
          <p className="text-sm text-[#A09B8C] mt-2">
            Zaloguj się, aby zarządzać turniejem TFT
          </p>
        </div>

        <form
          onSubmit={onSubmit}
          className="rounded-2xl border border-[#2A2A30] bg-[#121214] p-8 space-y-5"
        >
          <div>
            <label className="text-[10px] uppercase tracking-[0.25em] text-[#6E6A5E] font-bold mb-2 block">
              Email
            </label>
            <Input
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@tft.gg"
              className="bg-[#0A0A0B] border-[#2A2A30] text-[#F0E6D2] h-11 focus-visible:ring-[#0AC8B9]"
            />
          </div>

          <div>
            <label className="text-[10px] uppercase tracking-[0.25em] text-[#6E6A5E] font-bold mb-2 block">
              Hasło
            </label>
            <Input
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="bg-[#0A0A0B] border-[#2A2A30] text-[#F0E6D2] h-11 focus-visible:ring-[#0AC8B9]"
            />
          </div>

          {error && (
            <div
              data-testid="login-error"
              className="text-sm text-[#E84057] bg-[#E84057]/10 border border-[#E84057]/30 rounded-md px-3 py-2"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            data-testid="login-submit-button"
            disabled={submitting}
            className="w-full h-11 rounded-md bg-[#C8AA6E] hover:bg-[#DCC28A] text-[#0A0A0B] font-bold tracking-tight transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
          >
            <Lock className="h-4 w-4" />
            {submitting ? "Logowanie..." : "Zaloguj się"}
          </button>
        </form>
      </div>
    </div>
  );
}
